module.exports = __webpack_public_path__ + "img/Thailand.9755cfef.svg";